// promiseTypeSuffixes for redux-promise-middle-ware
export const PROMISE_TYPE_SUFFIXES = ['PENDING', 'FULLFILLED', 'REJECTED'];
export const [PENDING, FULLFILLED, REJECTED] = PROMISE_TYPE_SUFFIXES;
// IMPERSONATE
export const STOP_IMPERSONATE = 'STOP_IMPERSONATE';
export const FETCH_IMPERSONATE_USER_LIST = 'FETCH_IMPERSONATE_USER_LIST';
export const SET_MODAL_STATE = 'IS_MODAL_OPEN';
export const CALL_PASS_THROUGH = 'CALL_PASS_THROUGH';
export const GET_COUNTRY_LIST = 'GET_COUNTRY_LIST';
export const GET_STATE_LIST = 'GET_STATE_LIST';

export const FETCH_PROTOCOL_DEVIATIONS = 'FETCH_PROTOCOL_DEVIATIONS';

// ERROR
export const HANDLE_REQUEST = 'HANDLE_ERROR';

// OTHERS
export const MOCK_DATA = 'MOCK_DATA';

export const IS_MODAL_OPEN = 'IS_MODAL_OPEN';
export const IS_EDITING = 'IS_EDITING';
